<template>
  <div class="verification-page-template">
    <h5 class="text-center">Verification</h5>
    <p
      style="padding: 0 20px;"
      class="text-center"
    >We have sent you an access code via SMS and email for verification</p>
    <div class="input-wrapper">
      <Input
        style="width: 70%; margin-top: 10px;"
        size="large"
        :disabled="isLoading"
        clearable
        v-model="code"
        placeholder="Enter verification code"
      />
    </div>
    <div class="input-wrapper">
      <Button
        @click="verify"
        :disabled="isLoading"
        :loading="isLoading"
        style="margin-top: 10px;"
        long
        size="large"
        type="primary"
      >Verify</Button>
    </div>
    <div style="flex-direction: column;" class="input-wrapper">
      <small style="margin-top: 10px;">{{ mobile }}</small>
      <small>{{ email }}</small>
    </div>
    <div class="input-wrapper">
      <a @click="previousPage">
        Change
        <span v-if="email">Email &nbsp;</span>
        <span v-if="mobile && email">/</span>
        <span v-if="mobile">&nbsp;Phone Number</span>
      </a>
      <p style="margin: 0 4px;">or</p>
      <a @click="resendCode()">Resend Code</a>
    </div>
    <div class="input-wrapper">
      <div class="skip-for-now pointer" @click="skip">
        <p>Skip for now</p>
        <p style="margin-left: 6px;">
          <Icon size="12" type="chevron-right"></Icon>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Message } from "iview";
import VueCookie from "vue-cookie";
import _ from "lodash";

export default {
  name: "VerificationPage",
  data() {
    return {
      code: "",
      isLoading: false,
      isResending: false
    };
  },
  computed: {
    ...mapGetters("user", ["userInfo"]),
    mobile() {
      return this.verificationCookie
        ? this.verificationCookie.mobile
        : this.userInfo.contact_number;
    },
    email() {
      let firstUnverifiedEmail = _.filter(this.userInfo.email, email => {
        return email.validated_at == null;
      });

      return this.verificationCookie
        ? this.verificationCookie.email
        : firstUnverifiedEmail.length > 0
        ? firstUnverifiedEmail[0].email
        : this.userInfo.email && this.userInfo.email.length > 0
        ? this.userInfo.email[0].email
        : "";
    },
    verificationCookie() {
      return JSON.parse(
        VueCookie.get(Cons[0].PATHS.NAME + "VERIFICATION_SENT")
      );
    }
  },
  methods: {
    skip() {
      this.nextPage();
    },
    setIsVerificationSent(payload) {
      if (payload)
        VueCookie.set(Cons[0].PATHS.NAME + "VERIFICATION_SENT", payload);
      else VueCookie.delete(Cons[0].PATHS.NAME + "VERIFICATION_SENT");
    },
    async resendCode() {
      if (this.isResending) return;
      try {
        this.isResending = true;
        this.$store.commit("base/setLoadingPage", true, { root: 1 });
        let promises = [];
        if (this.mobile)
          promises.push(
            this.$store.dispatch("onBoarding/resendMobileCode", this.mobile)
          );
        if (this.email)
          promises.push(
            this.$store.dispatch("onBoarding/resendEmailCode", this.email)
          );
        await Promise.all(promises);
        this.setIsVerificationSent(
          JSON.stringify({
            email: this.email,
            mobile: this.mobile
          })
        );
        Message.success("Verification code sent");
      } catch (error) {
        this.showMessage("Unable to resend verification code");
      } finally {
        this.isResending = false;
        this.$store.commit("base/setLoadingPage", false, { root: 1 });
      }
    },
    validate() {
      if (!this.code) {
        this.showMessage("Verification code is required");
        return false;
      }
      return true;
    },
    async verify() {
      if (!this.validate()) return;
      try {
        this.isLoading = true;
        let result = await this.$store.dispatch(
          "onBoarding/validateCode",
          this.code
        );

        if (result.error) this.showMessage("Invalid verification code");
        else {
          this.setIsVerificationSent(null);
          this.nextPage();
        }
      } catch (error) {
        this.showMessage("Invalid verification code");
      } finally {
        this.isLoading = false;
      }
    },
    showMessage(content) {
      Message.warning(content);
    },
    nextPage() {
      this.$emit("nextPage");
    },
    previousPage() {
      this.$emit("previousPage");
    },
    goToLogin() {
      this.$emit("goToPath", "/login");
    }
  }
};
</script>

<style lang="scss">
.verification-page-template {
  .input-wrapper {
    input {
      text-align: center;
    }
  }
}
</style>

<style lang="scss" scoped>
.verification-page-template {
  display: flex;
  flex-direction: column;
  align-content: center;
}
.input-wrapper {
  justify-content: center;
  small:last-child {
    margin-top: 0px;
    margin-bottom: 10px;
  }
}
.text-center {
  text-align: center;
}
.skip-for-now {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>